import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { Card } from '../ui/Card';
import { OccupancyData } from '../../types';

interface OccupancyChartProps {
  data: OccupancyData[];
}

export const OccupancyChart: React.FC<OccupancyChartProps> = ({ data }) => {
  const totalOccupied = data.reduce((sum, item) => sum + item.occupied, 0);
  const totalVacant = data.reduce((sum, item) => sum + item.vacant, 0);

  const chartData = [
    { name: 'Ocupadas', value: totalOccupied },
    { name: 'Vacantes', value: totalVacant },
  ];

  const COLORS = ['#FA4999', '#E5E7EB'];

  return (
    <Card title="Distribución de Ocupación">
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  );
};

